var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-upload',{staticClass:"upload-demo",attrs:{"action":_vm.baseURL+_vm.url,"show-file-list":false,"on-success":_vm.addEventOnSuccess,"on-error":_vm.addEventOnError,"headers":_vm.headers,"on-progress":_vm.addOnProgress,"before-upload":_vm.beforeAvatarUpload,"multiple":_vm.multiple,"limit":999}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }